import { Form, Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import TriggerFormItems from "../../../../../components/FormItems/TriggerFormItems";
import { toast } from 'sonner'

export const TriggerModal = ({
    open, setOpen, assistantId, onFinish, initValues, okText = 'Criar', onSuccess = () => {
    }
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
      // TODO: improve FormParams component to remove this properties
    const properties = Form.useWatch(['args', 'parameters', 'properties'], form)

    useEffect(() => {
        if (form && initValues)
            form.setFieldsValue(initValues);
    }, [form, initValues]);

    const finish = useCallback((values) => {
        const requiredFields = []
        values.args.parameters.type = 'object';
        if (values?.args?.parameters?.properties) {
            let newProperties = {};
            for (const value of values.args.parameters.properties) {
                newProperties[value.name] = {
                    type: value.type,
                    description: value.description,
                    enum: value.limitOptions ? value.enum : []
                }

                if (value.items)
                    newProperties[value.name].items = value.items

                if (value.required)
                    requiredFields.push(value.name);
            }
            values.args.parameters.required = requiredFields;
            values.args.parameters.properties = newProperties;
        }

        if (Object.keys(values?.args?.parameters?.properties ?? {}).length <= 0)
            delete values.args.parameters;

        setLoading(true);
        onFinish(assistantId, values)
            .then(() => {
                setOpen(false);
                form.resetFields();
                onSuccess();
            })
            .catch((err) => {
                console.error(err);
                toast.error("Falha ao criar gatilho.");
            }).finally(() => {
                setLoading(false);
            });
    }, [assistantId, onSuccess])

    return <Modal open={open}
        confirmLoading={loading}
        onOk={() => form.submit()}
        onCancel={() => setOpen(false)}
        okText={okText}
        cancelText={'Cancelar'}>
        <Form onFinish={finish}
            form={form}
            layout={'vertical'}>
            <TriggerFormItems properties={properties} />
        </Form>
    </Modal>
}

